import api from "./api";
import endpoints from "./endpoints";

export default {
  get(languages) {
    return api
      .get(endpoints.attributeManager.mediaAssetTypes.get, {
        params: { languages }
      })
      .then((x) => Promise.resolve(x.data));
  },
  update(model) {
    return api.post(endpoints.attributeManager.mediaAssetTypes.update, model).then((x) => Promise.resolve(x.data));
  },
  delete(items) {
    return api.post(endpoints.attributeManager.mediaAssetTypes.delete, items).then((x) => Promise.resolve(x.data));
  },
  validateInitialRelativePath(path, mediaAssetTypeId) {
    return api
      .get(endpoints.attributeManager.mediaAssetTypes.validateInitialRelativePath, { params: { path, mediaAssetTypeId } })
      .then((x) => Promise.resolve(x.data));
  },
  savedeepLTranslated: async function (model, sourceLanguage) {
    return api
      .post(endpoints.attributeManager.mediaAssetTypes.deepL, model, { params: { sourceLanguage: sourceLanguage } })
      .then((x) => Promise.resolve(x.data));
  }
};
